<script>
export default {
  name: 'form-helpers',
  methods: {
    clearError (fieldName) {
      let pos = this.errors.indexOf(fieldName);

      if (pos > -1) {
        this.errors.splice(pos, 1);
      }
    },
    clearErrors (fieldNames) {
      let fields = fieldNames.split(',');

      for (let i = 0; i < fields.length; i++) {
        this.clearError(fields[i]);
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/FormHelpers.vue